<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate " [title]="'global.overview'|translate">
        <app-grid [grid]="grid" ></app-grid>
        <button class="btn btn-primary ripple light pull-right my-3" routerLink="/back-office/model/overview"
           type="button">{{'admin.model.view_models'|translate}}</button>
      </app-card>
    </div>
  </div>
</div>
<app-modal-basic #readdModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'Model'} }}</h4>
    <button type="button" class="close basic-close" (click)="readdModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <span [innerHTML]="modelName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="readdModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="readd()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>

